'use client';
// eslint-disable-next-line deprecate/import
import Link from 'next/link';

import { Faq } from '@ui/uikit/components/common/Faq';

import { MAGIC_RAFFLE_FAQ_ITEMS } from './faqItems';

export const MagicRaffleFaq = () => {
  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between items-start md:items-center mb-8">
        <h2 className="text-h3-a mb-4 md:mb-0">Magic Raffles FAQ</h2>
        <Link
          href="https://docs.magicsquare.io/magic-store/for-users/magic-raffles"
          target="_blank"
          className="max-sm-msq:w-full"
        >
          <button className="msq-btn msq-btn-md msq-btn-secondary max-sm-msq:w-full">
            How It Works
          </button>
        </Link>
      </div>
      <Faq faqItems={MAGIC_RAFFLE_FAQ_ITEMS} />
    </div>
  );
};
